(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("i18next"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["i18next", "jQuery"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("i18next"), require("jQuery")) : factory(root["i18next"], root["jQuery"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 